import React from "react";

import { WrappedLink } from "@components/navigation";
import { useRootAppStore } from "@hooks";
import { useAppContext } from "@state/hooks/shared";
import { isGamesTheme } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { observer } from "mobx-react-lite";

export default observer(function HeaderLogo() {
	const { culture } = useAppContext();
	const rootStore = useRootAppStore();

	const returnUrl = new URL(window.location.href).searchParams.get(
		"returnUrl"
	);

	const homeUrl = returnUrl
		? `/${culture}/${DefaultPath.HOME}?returnUrl=${returnUrl}`
		: `/${culture}/${DefaultPath.HOME}`;

	return (
		<figure className="header__figure">
			<WrappedLink to={homeUrl} className="header__figure__link">
				{rootStore.themeStore.isLightTheme ? (
					<>
						<img
							className="header__logo"
							src="/assets/images/logo-dark.svg"
							alt=""
						/>
						<div className="header__logo--sml" />
					</>
				) : (
					<>
						<img
							className="header__logo"
							src="/assets/images/logo.svg"
							alt=""
						/>
						<div className="header__logo--sml" />
					</>
				)}

				{isGamesTheme() && (
					<figcaption className="header__logo__text">
						Games
					</figcaption>
				)}
			</WrappedLink>
		</figure>
	);
});
